var map = {
	"./arr-g.png": 530,
	"./arr-r.png": 531,
	"./arr-y.png": 532,
	"./high-left-2.png": 533,
	"./high-left-3.png": 534,
	"./high-left-4.png": 535,
	"./high-middle-2.png": 536,
	"./high-middle-3.png": 537,
	"./high-middle-4.png": 538,
	"./high-none-2.png": 539,
	"./high-none-3.png": 540,
	"./high-none-4.png": 541,
	"./high-right-2.png": 542,
	"./high-right-3.png": 543,
	"./high-right-4.png": 544,
	"./high-twoedge-2.png": 545,
	"./high-twoedge-3.png": 546,
	"./high-twoedge-4.png": 547,
	"./low-2.png": 548,
	"./low-3.png": 549,
	"./low-4.png": 550,
	"./middle-left-2.png": 551,
	"./middle-left-3.png": 552,
	"./middle-left-4.png": 553,
	"./middle-middle-2.png": 554,
	"./middle-middle-3.png": 555,
	"./middle-middle-4.png": 556,
	"./middle-none-2.png": 557,
	"./middle-none-3.png": 558,
	"./middle-none-4.png": 559,
	"./middle-right-2.png": 560,
	"./middle-right-3.png": 561,
	"./middle-right-4.png": 562,
	"./middle-twoedge-2.png": 563,
	"./middle-twoedge-3.png": 564,
	"./middle-twoedge-4.png": 565
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 529;